import { render } from "./dailyRituals.vue?vue&type=template&id=fb5f7040&scoped=true"
import script from "./dailyRituals.vue?vue&type=script&lang=js"
export * from "./dailyRituals.vue?vue&type=script&lang=js"

import "./dailyRituals.vue?vue&type=style&index=0&id=fb5f7040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb5f7040"]])

export default __exports__